import type { PaymentDto } from "./api/payments-api";
import { formatMoney } from "./invoice-mappers";

const PAYMENT_MODE_LABEL: Record<string, string> = {
  CASH: "Cash",
  BANK: "Bank Transfer",
  CARD: "Card",
  UPI: "UPI",
  CHEQUE: "Cheque",
  OTHER: "Other",
};

function formatPaidAt(iso: string) {
  return new Date(iso).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function paymentToTableRow(p: PaymentDto, index: number) {
  const paymentId = p.reference ?? `PAY-${p.id.slice(0, 8).toUpperCase()}`;
  return {
    key: p.id,
    rowId: p.id,
    id: String(index + 1),
    img: `avatar-${(index % 12) + 1}.jpg`,
    Customer: p.customer.displayName,
    Payment_ID: paymentId,
    Paid_Date: formatPaidAt(p.paidAt),
    Amount: formatMoney(p.amount, p.invoice.currency),
    Payment_method: PAYMENT_MODE_LABEL[p.paymentMode] ?? p.paymentMode,
    invoiceId: p.invoice.id,
    invoiceNumber: p.invoice.number,
    paidAtIso: p.paidAt,
  };
}
